<template>
  <div class="spnod-admin__form--container container px-0 mx-0 w-100 h-100">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-form-input
        v-model="$v.form.name.$model"
        name="name"
        :state="validateState('name')"
        type="text"
        placeholder="Name"
        size="sm"
        class="mb-2"
      ></b-form-input>
      <b-form-textarea
        v-model="$v.form.description.$model"
        name="description"
        :state="validateState('description')"
        type="text"
        rows="3"
        placeholder="Description"
        size="sm"
        class="mb-4"
      >
      </b-form-textarea>
      <b-form-group class="d-flex justify-content-end">
        <b-button class="spnod-admin__form--button" type="submit" :disabled="isDisabled" size="sm">
          <p v-if="!isSaving">Save</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateAGroup',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        name: '',
        description: ''
      },
      isSaving: false
    }
  },
  computed: {
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some(obj => obj[1] === '')
      return anyBlanks || this.$v.form.$anyError
    }
  },
  methods: {
    ...mapActions(['createGroup', 'resetActiveGroup']),
    handleSubmit: async function () {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.isSaving = true
      await this.createGroup(this.form)
      this.isSaving = false
      this.$router.push('/bulk')
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    }
  },
  mounted() {
    this.resetActiveGroup()
  },
  validations: {
    form: {
      name: { required },
      description: { required }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/CreateGroupForm.vue?17238c60